
export default function Hero() {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://public.readdy.ai/ai/img_res/9e3f61851412f53848bd86eed8283e5f.jpg')`
      }}
    >
      <div className="container mx-auto px-6 text-center relative z-10">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6">
            ZÓNA s.r.o.
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-8 leading-relaxed">
            Secure Your Digital Life with Advanced VPN Technology
          </p>
          <p className="text-lg text-white/80 mb-12 max-w-2xl mx-auto">
            Professional VPN solutions designed to protect your privacy, secure your data, and provide unrestricted internet access across all your devices.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="#features" 
              className="px-8 py-4 bg-blue-600 text-white rounded-full font-semibold hover:bg-blue-700 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Explore Features
            </a>
            <a 
              href="#contact" 
              className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white border-2 border-white rounded-full font-semibold hover:bg-white/20 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Get in Touch
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
